export default {
  state: {
    menu: null,
    dish: null,
    categoriesAccordion: {}
  },
  getters: {
    menu: state => state.menu || {},
    menuId: state => {
      if (!state.menu) {
        return;
      }
      return state.menu.id;
    },
    menuInfo: state => {
      if (!state.menu) {
        return {};
      }
      const { Categories, ...rest } = state.menu;
      return rest;
    },
    categories: state => {
      if (!state.menu) {
        return [];
      }
      const { Categories } = state.menu;
      return Categories;
    },
    categoriesAccordion: state => {
      if (!state.menu) {
        return {};
      }
      return state.categoriesAccordion;
    },
    categoriesLength: (state, getters) => {
      const length = getters.categories.length;
      return length;
    },
    dish: state => state.dish || {},
    dishId: state => {
      if (!state.dish) {
        return;
      }
      return state.dish.id;
    },
    dishModifiers: state => state.dish.DishModifiers || []
  },
  mutations: {
    setMenu: (state, payload) => {
      state.menu = payload;
      const obj = {};
      payload.Categories.forEach(element => {
        obj[element.id] = false;
      });
      state.categoriesAccordion = { ...obj, ...state.categoriesAccordion };
    },
    setDishModel: state => {
      const model = {
        name: "",
        price: 0,
        inStock: true,
        photoUrl: "",
        description: "",
        availableFrom: null,
        availableTo: null
      };
      state.dish = { ...model };
    },
    updateDishModel: (state, payload) => {
      state.dish = {
        ...state.dish,
        ...payload
      };
    },
    toggleCategoryMenu: (state, { elms, condition = true }) => {
      // state.categoriesAccordion[payload] = !state.categoriesAccordion[payload];
      if (typeof elms === "string") {
        state.categoriesAccordion[elms] = condition;
      } else if (Array.isArray(elms)) {
        elms.forEach(el => {
          state.categoriesAccordion[el.id] = condition;
        });
      }
      state.categoriesAccordion = {
        ...state.categoriesAccordion
      };
    }
  },
  actions: {},
  namespaced: true
};
